
import React from 'react';
// material
import { Grid } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
// entities
import { Campaign } from '../../../../entities/site';
// components
import PieChart from './PieChart';
import ActionButton from '../../../../components/buttons/ActionButton';
import HasAccess from '../../../../components/auth/HasAccess';
// services
import { Roles } from '../../../../services/auth';

interface CampaignStatsProps {
  campaign: Campaign;
  onUpdate?(campaign: Campaign): void;
}

const CampaignStats: React.FC<CampaignStatsProps> = (props) => {
  return (
    <Grid container>
      <Grid item xs={3} style={styles.left}>
        <div style={styles.mainStat}>
          <div style={styles.title}>Total Sent</div>
          <div style={styles.value}>{props.campaign.totalSent}</div>
          <div style={styles.valueBottom}>of {props.campaign.totalContacts}</div>
        </div>
      </Grid>
      <Grid item xs={9} style={styles.right}>
        <div style={styles.boxContainer}>

          <div style={styles.box}>
            <div style={styles.title}>Active</div>
            <div style={styles.boxBody}>
              <div style={styles.chart}><PieChart size="lg" stat={props.campaign.totalActive} total={props.campaign.totalContacts} /></div>
              <div style={styles.value}>{props.campaign.totalActive}</div>
            </div>
          </div>

          <div style={styles.box}>
            <div style={styles.title}>Click Throughs</div>
            <div style={styles.boxBody}>
              <div style={styles.chart}><PieChart size="lg" stat={props.campaign.totalClicks} total={props.campaign.totalContacts} /></div>
              <div style={styles.value}>{props.campaign.totalClicks}</div>
            </div>
          </div>

          <div style={styles.box}>
            <div style={styles.title}>Opt Outs</div>
            <div style={styles.boxBody}>
              <div style={styles.chart}><PieChart size="lg" stat={props.campaign.totalOptOuts} total={props.campaign.totalContacts} /></div>
              <div style={styles.value}>{props.campaign.totalOptOuts}</div>
            </div>
          </div>

          <div style={styles.box}>
            <div style={styles.title}>Non Responsive</div>
            <div style={styles.boxBody}>
              <div style={styles.chart}><PieChart size="lg" stat={props.campaign.totalNonResponsive} total={props.campaign.totalContacts} /></div>
              <div style={styles.value}>{props.campaign.totalNonResponsive}</div>
            </div>
          </div>

        </div>
      </Grid>
      <Grid item xs={12}>
        <HasAccess roles={[Roles.admin, Roles.superadmin]} notRoles={[Roles.textadmin]}>
          <div style={styles.link}>
            <SyncIcon style={styles.linkicon} />
            <ActionButton
              textOnly
              name="Sync Campaigns Totals"
              onClick={() => props.onUpdate !== undefined ? props.onUpdate(props.campaign) : null}
            />
          </div>
        </HasAccess>
      </Grid>
    </Grid>
  );
};

export default CampaignStats;

const styles: any = {

  container: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  left: {
    border: '1px solid #E0E0E0'
  },
  right: {
    borderTop: '1px solid #E0E0E0',
    borderRight: '1px solid #E0E0E0',
    borderBottom: '1px solid #E0E0E0',
  },
  mainStat: {
    padding: '25px 100px'
  },
  boxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  box: {
    padding: 25
  },
  boxBody: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    fontSize: 20,
    paddingBottom: 20,
    textAlign: 'center'
  },
  value: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#627995',
    textAlign: 'center'
  },
  valueBottom: {
    fontSize: 20,
    textAlign: 'center'
  },
  chart: {
    height: 80,
    width: 80
  },
  link: {
    color: "#00ABCA",
    fontSize: 16,
    marginRight: 30.5,
    paddingTop: 27,
    display: "flex",
    justifyContent: 'flex-end'
  },
  linkicon: {
    marginRight: 7,
  },
};


// WEBPACK FOOTER //
// ./src/pages/admin/campaign/components/CampaignStats.tsx